const en = {
    popupTitle: 'Write a Message',
    submitBtn: 'Send the Message',
}

const rus = {
    popupTitle: 'Написать сообщение',
    submitBtn: 'Отправить сообщение',

}

const hebrew = {
    popupTitle: 'Write a Message',
    submitBtn: 'Send the Message',
}

const choose = { en, rus, hebrew };

export default choose;